'use strict'

import {
    serverApi
} from '@/server';


export default {
    /**
     * 流水统计
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /dashboard/statistics
     */
    dashboardStatistics(formData) {
        let url = `/dashboard/statistics`;
        return serverApi.post(formData, url);
    },
    /**
     * 业务概览
     *
     * @author nick
     *
     * @method POST
     * 
     * @url /dashboard/overview
     * @param {Object} formData
     * @returns {Promise}
     */
    dashboardOverview(formData) {
        const url = '/dashboard/overview'
        return serverApi.post(formData, url)
    },
}
